<div class="modal-header">
    <h4 class="modal-title">Select the pages you want to Connect</h4>
    <button type="button" class="btn btn-clear kt-padding-0 kt-svg-icon kt-svg-icon-solid" aria-label="Close" 
        (click)="close()" [inlineSVG]="'Navigation/Close.svg'">

    </button>
</div>
<div class="modal-body">
    <form [formGroup]="facebookPagesList">
        <div formArrayName="pageslist">
            <div class="page" *ngFor="let page of pages; let i = index">
                <label class="kt-checkbox kt-checkbox--solid">
                    <input type="checkbox" [formControlName]="i" /> 
                    <img [src]="page.picture" />
                    {{page.name}}
                    <span></span>
                </label>
            </div>
        </div>
    </form>

</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="linkPages()">Link Pages</button>
</div>